<div class="modal-container">
  <div class="modal-top">
    <h2 mat-dialog-title>Ställ en fråga</h2>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div mat-dialog-content>
    <form [formGroup]="askForm">
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <textarea
              formControlName="question"
              matInput
              placeholder="Din fråga"
            ></textarea>
            <mat-error *ngIf="askForm.controls.question.hasError('required')">
              Din fråga <strong>krävs</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input
              formControlName="email"
              matInput
              placeholder="E-postadress"
            >
            <mat-error
              *ngIf="
                askForm.controls.email.hasError('email') &&
                !askForm.controls.email.hasError('required')
              "
            >
              Ange en giltig e-postadress
            </mat-error>
            <mat-error *ngIf="askForm.controls.email.hasError('required')">
              E-postadress <strong>krävs</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-checkbox
            color="primary"
            disableRipple
            formControlName="isPublic"
          >
            Jag godkänner att svaret visas på Vården.se
          </mat-checkbox>
        </div>
        <div class="col-12">
          <mat-checkbox
            color="primary"
            disableRipple
            formControlName="datapolicy"
          >
            Jag har läst och accepterar:
            <a href="/villkor" target="_blank">Allmänna villkor</a> &
            Integritetspolicy
            <mat-error
              *ngIf="
                askForm.controls.datapolicy.hasError('pattern') &&
                askForm.controls.datapolicy.touched
              "
            >
              För att skicka in din information måste du godkänna Allmänna
              villkor & Integritetspolicy.
            </mat-error>
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-actions" mat-dialog-actions>
    <app-ui-button
      (onClick)="saveQuestion()"
      [color]="'secondary'"
      [compressed]="false"
      [expanded]="'inline'"
      [size]="'lg'"
    >
      Skicka
    </app-ui-button>

    <app-ui-button
      (onClick)="closeDialog()"
      [color]="'ghost'"
      [compressed]="false"
      [expanded]="'inline'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>
</div>
